import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createPortal } from "react-dom";
import toast from "@src/utils/toast";
import { addComma, HOSTNAME, isExternalUrl } from "@src/utils";
import { TWeddingHallCard } from "@src/types/weddingHall";
import { addLikeWeddinghall, removeLikeWeddinghall } from "@src/api/weddingHall/weddingHall";
import HallImgCarousel from "../infomation/HallImgCarousel";
import Icon from "@src/components/common/icons/Icon";
import Modal from "@src/components/common/modal/Modal";
import { UserContext } from "@src/App";
import "./homeHallCard.scss";
import { useSelector } from "react-redux";
import { RootState } from "@src/store";
import { IAdvertise } from "@src/types/advertise";
import { logEvent } from "@src/reactGa";
import useDuplicateBooking from "@src/utils/hooks/useBookingState";
import { UMOMENT_HALL } from "@src/types/realtimeBooking";

type Props = {
  hallInfo: TWeddingHallCard | IAdvertise;
  handleCardClick?: () => void;
  setMoreBottomSheet?: (bool) => void;
  setReservationBottomSheet?: (bool) => void;
  hasLike?: boolean;
  hasShadow?: boolean;
  adType?: "weddinghall" | "slot" | "region";
};

/**
 *
 * 상품(슬롯) 카드
 * @param hallInfo 웨딩홀 기본 정보
 * @param thumbnails 웨딩홀 이미지 배열
 * @param hasLike 하트 아이콘 사용 여부(옵셔널)
 * @param hasShadow 카드 외부 그림자 효과
 * @param adType 광고 유형 (웨딩홀, 잔여타임, 이 주변 추천)
 */
const HomeHallCard = ({
  hallInfo,
  hasLike = true,
  handleCardClick,
  // setMoreBottomSheet,
  hasShadow = false,
  adType = null,
}: Props) => {
  const user = useContext(UserContext);
  const listLayout = useSelector((state: RootState) => state.weddingHall.listLayout); // list or grid
  const carouselWidth = listLayout === "grid" ? window.innerWidth / 2 - 20 : window.innerWidth - 40;
  const carouselHeight = listLayout === "grid" ? carouselWidth : 300;

  const {
    availableContract,
    storedToConsulting,
    consultingUsed,
    partnerUuid,
    partnerProfileName,
    isLike,
  } = hallInfo;

  const [isFullHeart, setIsFullHeart] = useState(!!isLike && hasLike);
  const [badges, setBadges] = useState<string[]>([]);

  const { isDuplicateBooking, setIsDuplicateBooking, getDuplicateReservation } =
    useDuplicateBooking();

  useEffect(() => {
    if (availableContract && storedToConsulting && consultingUsed) {
      setBadges(["즉시 방문 예약", "즉시 잔여타임 선점"]);
    } else if (availableContract === true) {
      setBadges(["즉시 잔여타임 선점"]);
    } else if (availableContract === false && storedToConsulting && consultingUsed) {
      setBadges(["즉시 방문 예약"]);
    } else {
      setBadges([]);
    }
  }, [availableContract, storedToConsulting, consultingUsed]);

  const clickHeartIcon = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setIsFullHeart(!isFullHeart);
    if (isFullHeart === false) {
      addLikeWeddinghall(partnerUuid, partnerProfileName).then((res) => {
        if (res === 200) {
          toast.showSnackbar("위시리스트에 추가했습니다.", {
            buttonText: "위시리스트 가기",
            onClick: () => {
              window.location.href = isExternalUrl(`${HOSTNAME}/my-interest/like/slot?tab=hall`);
            },
          });
        } else {
          setIsFullHeart(false);
        }
      });
    } else {
      removeLikeWeddinghall(partnerUuid, partnerProfileName).then((res) => {
        if (res === 200) {
          toast.showSnackbar("위시리스트에서 삭제했습니다.", { isShowClose: true });
        } else {
          setIsFullHeart(true);
        }
      });
    }
  };

  const clickHallCard = (e, partnerUuid: string) => {
    e.stopPropagation();
    logEvent("component_behavior", {
      component: "HallCard",
      behavior: "click",
      content: hallInfo.partnerProfileName,
    });
    if (adType) {
      logEvent("advertisement", {
        component: "HallCard",
        behavior: "click",
        content: hallInfo.partnerProfileName,
        advertisement_campaign: "웨딩홀 전환",
        advertisement_group: adType === "slot" ? "잔여타임 리스트" : "웨딩홀 리스트",
        advertisement_name: (hallInfo as IAdvertise).adName,
        advertisement_code: (hallInfo as IAdvertise).adCode,
      });
    }
    const url =
      adType === "slot"
        ? `${HOSTNAME}/weddinghall/${partnerUuid}?tabId=2`
        : `${HOSTNAME}/weddinghall/${partnerUuid}`;
    window.location.href = isExternalUrl(url);
  };

  const priceToString = (min, max) => {
    if (min === max) {
      return `${min}원`;
    } else {
      return listLayout === "grid" ? `${min}원~` : `${min}원 ~ ${max}원`;
    }
  };

  return (
    <div
      //partnerProfileId-> partnerProfileUuid로 변경(잔여타임 광고에서는 partnerProfileId 없음..)
      className={`home-card-wrap card-${hallInfo.partnerProfileUuid} ${hasShadow ? "shadow" : ""}`}
    >
      <div className="search-warp" onClick={(e) => clickHallCard(e, hallInfo.partnerUuid)}>
        <div className={`hall-img-wrap advertise-${adType}-wrap`}>
          <HallImgCarousel
            type="hall"
            indicatorType={listLayout === "grid" ? "none" : "dot"}
            height={adType !== "slot" ? carouselHeight : 165}
            width={adType !== "slot" ? carouselWidth : null}
            swipeable={adType !== "slot"} //잔여타임 광고구좌는 이미지 스와이프 불가
            imgs={hallInfo.partnerProfileImages}
            imgClick={() => {}}
            isDiscount={hallInfo.benefits.some((benefit) => benefit.tag === "할인")}
          />
          {hasLike && (
            <i
              // className={`icon ${isFullHeart ? "icon-heart-filled" : "icon-heart-white"} large`} 1열 리스트일 때는 하트 색상이 흰색
              className={`icon ${isFullHeart ? "icon-heart-filled" : "icon-heart-not-filled"} ${listLayout === "grid" ? "grid" : ""}`}
              onClick={clickHeartIcon}
            />
          )}
        </div>
        <div className={`hall-info-wrap ${adType ? adType : ""}`}>
          <span className="hall-info-region">
            {hallInfo.region} {hallInfo.subRegion}
          </span>
          <h2>{hallInfo.partnerProfileName}</h2>
          <p className={`price-range`}>
            <span>{`[정가] 대관료`}</span>
            {hallInfo.minRentalPrice === 0 ? (
              <span>문의 시 안내</span>
            ) : (
              <span>
                {addComma(priceToString(hallInfo.minRentalPrice, hallInfo.maxRentalPrice))}
              </span>
            )}
          </p>
          <p className={`price-range`}>
            <span>{`[정가] 식대`}</span>
            {hallInfo.minMealPrice === 0 ? (
              <span>문의 시 안내</span>
            ) : (
              <span>{addComma(priceToString(hallInfo.minMealPrice, hallInfo.maxMealPrice))}</span>
            )}
          </p>
          {adType === "slot" && "discountRate" in hallInfo && "finalPrice" in hallInfo && (
            <p className={`${adType}-price`}>
              {hallInfo.discountRate > 0 && (
                <span className="discount">{hallInfo.discountRate}%</span>
              )}
              {hallInfo.finalPrice > 0 && <span>{addComma(hallInfo.finalPrice)}원</span>}
            </p>
          )}
        </div>
        {/* {hallInfo.availableContract ? (
              <button
                className={`btn btn-full ${listLayout === 'grid' ? 'btn-tiny' :'btn-small'} btn-gray50 ${adType ? adType :''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCardClick()
                  setMoreBottomSheet && setMoreBottomSheet(true);
                }}
              >
                최종 견적
              </button>
            ) : (
              <button
                className={`btn btn-full  ${listLayout === 'grid' ? 'btn-tiny' :'btn-small'} btn-gray50 ${adType ? adType :''}`}
                onClick={async (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleCardClick()
                  if (hallInfo.partnerUuid && UMOMENT_HALL.has(hallInfo.partnerUuid)) {
                    window.location.href = isExternalUrl(`${HOSTNAME}/booking/real-time/${hallInfo.partnerUuid}/${hallInfo.partnerId}/visit-date`);
                  } else{
                    await getDuplicateReservation(hallInfo.partnerUuid,user.me.uuid,hallInfo.partnerId, true);
                  }
                }}
              >
                방문·할인 문의
              </button>
            )} */}
        {(hallInfo.benefits.length > 0 || hallInfo.availableContract) && (
          <div className="badge-wrap">
            {hallInfo.consultingUsed &&
              hallInfo.storedToConsulting &&
              hallInfo?.consultingUseAutoApproval && <Badge icon="Thunder" iconColor="#F53F29" />}
            {hallInfo.benefits.map((benefit, idx) => {
              if (benefit.tag !== "할인") {
                return (
                  <Badge
                    text={benefit.tag}
                    key={`hall-list-badge-${benefit.tag}-${hallInfo.partnerUuid}-${idx}`}
                  />
                );
              }
            })}
            {adType === "weddinghall" && <Badge text="AD" />}
          </div>
        )}
      </div>
      {/* <DuplicateReservationModal
        isDuplicate={isDuplicateBooking}
        setIsDuplicate={setIsDuplicateBooking}
      /> */}
    </div>
  );
};

export default HomeHallCard;

export const Badge = ({
  icon,
  iconColor,
  text,
}: {
  icon?: string;
  iconColor?: string;
  text?: string;
}) => {
  const bgColor = () => {
    if (icon) return "#FFF3F0";
    switch (text) {
      case "캐시백":
        return "#F7F3EF";
      case "할인":
        return "#FFF3F0";
      default:
        return "#F7F7F7";
    }
  };

  const fontColor = () => {
    switch (text) {
      case "캐시백":
        return "#9D7D54";
      case "할인":
        return "#F53F29";
      case "이벤트":
        return "#F53F29";
      default:
        return "#8A8A8A";
    }
  };
  return (
    // icon padding이 디자인 상 텍스트랑 다르게 2px이라 하드코딩..
    <div
      className="badge"
      style={
        icon ? { padding: "1px 2px", backgroundColor: bgColor() } : { backgroundColor: bgColor() }
      }
    >
      {icon && <Icon name={icon} size={"size-auto"} color={iconColor} />}
      {text && <span style={{ color: fontColor() }}>{text}</span>}
    </div>
  );
};

//사파리에서 이상하게 나와서 portal로 처리 (컨테이너 > container-type 속성?)
export const DuplicateReservationModal = ({ isDuplicate, setIsDuplicate }) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const navigate = useNavigate();
  return createPortal(
    <div>
      <Modal
        isShow={isDuplicate}
        overlay={true}
        overlayValue={0.5}
        text={`동일한 웨딩홀에 방문 예약이 존재합니다.
            예약된 일정을 확인 후 다시 진행해주세요.`}
        buttons={[
          {
            name: "닫기",
            className: "btn-gray50",
            action: () => {
              setIsDuplicate(false);
            },
          },
          {
            name: "예약내역",
            className: "btn-red500",
            action: () => {
              window.location.href = isExternalUrl(
                `${HOSTNAME}/my-reservation/weddinghall?tab=visit`,
              );
            },
          },
        ]}
      />
    </div>,
    document.body,
  );
};
